import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {DEFAULT_TOO_MANY_PRODUCTS_ERROR_MESSAGE} from '~/constants/ProductConstants';
import {TOO_MANY_PRODUCTS_ERROR_MESSAGE as FUNDRAISING_TOO_MANY_PRODUCTS_ERROR_MESSAGE} from '~/constants/FundraisingConstants';
import {Button, Stack} from '@customink/pigment-react';
import {isFundraisingMode} from '~/selectors/LabModeSelectors';
import {useSelector} from 'react-redux';

function getErrorMessage(isFundraisingMode) {
  if (isFundraisingMode) {
    return FUNDRAISING_TOO_MANY_PRODUCTS_ERROR_MESSAGE;
  } else {
    return DEFAULT_TOO_MANY_PRODUCTS_ERROR_MESSAGE;
  }
}

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function TooManyProducts({dismiss, ...props}) {
  const fundraisingMode = useSelector(isFundraisingMode);

  return (
    <Notification {...props} title="Too many products">
      <p>{getErrorMessage(fundraisingMode)}</p>
      <Stack className="notification-stack">
        <Button
          className="notification-cta"
          size="large"
          variant="secondary"
          href="#/help"
          onClick={dismiss}>
          Contact Us
        </Button>
        <Button
          className="notification-cta"
          size="large"
          variant="link"
          onClick={dismiss}>
          Close
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func,
  isFundraisingMode: PropTypes.bool
};

TooManyProducts.propTypes = propTypes;

TooManyProducts.displayName = 'TooManyProducts';
